import React from 'react'

import {
  PromotionBoxStyled,
  PromotionBoxImageStyled,
  PromotionBoxContentStyled,
  PromotionBoxTitleStyled,
  PromotionBoxSubtitleStyled,
  PromotionBoxDescriptionStyled,
  PromotionBoxListStyled,
  PromotionBoxListHeadStyled,
  PromotionBoxListBodyStyled,
  PromotionBoxFooterStyled,
  PromotionBoxFooterCaptionStyled,
  PromotionBoxFooterButtonStyled,
  PromotionListStyled,
  PromotionListItemStyled
} from './styles'
import { PromotionBoxProps } from './types'
import Button from './../../atoms/Button'
import Image from './../../atoms/Image'
import LinkWrapper from './../../atoms/LinkWrapper'

const PromotionBox: React.FC<PromotionBoxProps> = ({ data }) => {
  const { image, title, subtitle, description, list, pdf, cta } = data

  return (
    <PromotionBoxStyled>
      <PromotionBoxImageStyled>
        {image && <Image fluid={image.childImageSharp} alt={image.alt} objectFit="cover" />}
      </PromotionBoxImageStyled>
      <PromotionBoxContentStyled>
        <PromotionBoxTitleStyled as="h3">{title}</PromotionBoxTitleStyled>
        {subtitle && <PromotionBoxSubtitleStyled as="p">{subtitle}</PromotionBoxSubtitleStyled>}
        {description && <PromotionBoxDescriptionStyled as="p">{description}</PromotionBoxDescriptionStyled>}
        {list && (
          <PromotionBoxListStyled>
            {list.head && <PromotionBoxListHeadStyled as="p">{list.head}</PromotionBoxListHeadStyled>}
            {list.body && (
              <PromotionBoxListBodyStyled>
                <PromotionListStyled>
                  {list.body.map(({ key, value }) => (
                    <PromotionListItemStyled {...{ key }}>{value}</PromotionListItemStyled>
                  ))}
                </PromotionListStyled>
              </PromotionBoxListBodyStyled>
            )}
          </PromotionBoxListStyled>
        )}
        <PromotionBoxFooterStyled>
          {pdf && (
            <LinkWrapper url={pdf.url} urlIsExternal>
              <PromotionBoxFooterCaptionStyled as="span">{pdf.urlText}</PromotionBoxFooterCaptionStyled>
            </LinkWrapper>
          )}
          {cta && (
            <PromotionBoxFooterButtonStyled>
              <Button variant="withArrow" {...cta} />
            </PromotionBoxFooterButtonStyled>
          )}
        </PromotionBoxFooterStyled>
      </PromotionBoxContentStyled>
    </PromotionBoxStyled>
  )
}

export default PromotionBox
